import Vue from 'vue'
//单服务暴露的接口,注册到全局，供其他服务调用
export default {
	bq401003List: ["吸烟", "不吸烟"],
	bq401006List: ["饮酒", "不饮酒"],
	existList: ["","有", "无"],
	booleanList: ["是", "否"],
	bq001032List: ["健在", "死亡"],
	bq0010323List: ["肝病相关", "非肝病相关"],
	bq4170153List: ["超声提示肝癌", "CT或磁共振提示肝癌", "肝脏病理提示肝癌", "其他"],
	bq4170213List: ["超声提示结节、轮廓不规则、表面不光滑等声像图", "CT、磁共振提示肝硬化", "肝脏病理提示肝硬化", "FibroTouch或Fibroscan: F4>12.5 kPa",
		"食管胃底静脉曲张", "腹水", "食管胃底静脉曲张破裂出血", "肝性脑病", "其他"
	],
	familyList: ["父亲", "母亲", "兄弟姐妹", "其他","无"],
	getAllTreatment(funSuccess) {
		let v = new Vue()
		let condition = {
			currentPage: 1,
			pageSize: 10000,
			recordCount: 0,
			menuid: v.$utils.MenuEnum.bd002
		}

		v.$utils.HttpPost(v.$utils.Url.s400 + '/api/S400Bd002/List', condition, function(d) {
			let dataList = d.data
			// 处理数据，加上文本显示列
			dataList.forEach(function(item) {
				v.$utils.CopyKeyInfo(item,item)
				item.label = item.Bd002_002 + '   ' + item.Bd002_003
			})
			console.log(dataList)
			funSuccess(dataList)
		}, null, null, null);
	}

}
